module.exports = __webpack_public_path__ + "img/trackd-social-music-platform.44bc3a97.svg";